import { useState, useCallback } from 'react'
import { LandUsePlanDocument } from '@popety-io/types'

interface UseDocumentModalReturn {
  isOpen: boolean
  selectedDocument: LandUsePlanDocument | null
  openModal: () => void
  closeModal: () => void
  selectDocument: (document: LandUsePlanDocument) => void
}

export const useDocumentModal = (): UseDocumentModalReturn => {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedDocument, setSelectedDocument] =
    useState<LandUsePlanDocument | null>(null)

  const openModal = useCallback(() => {
    setIsOpen(true)
  }, [])

  const closeModal = useCallback(() => {
    setIsOpen(false)
    // Clear selected document after modal animation completes
    setTimeout(() => {
      setSelectedDocument(null)
    }, 300)
  }, [])

  const selectDocument = useCallback((document: LandUsePlanDocument) => {
    setSelectedDocument(document)
  }, [])

  return {
    isOpen,
    selectedDocument,
    openModal,
    closeModal,
    selectDocument,
  }
}
